import script from "./WeswapBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./WeswapBanner.vue?vue&type=script&setup=true&lang=js"

import "./WeswapBanner.vue?vue&type=style&index=0&id=026610c2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-026610c2"]])

export default __exports__